import React, { useState } from 'react';
import styles from './FormLocCasa.module.css';
import { criarImovelComImagens } from '../../services/api';

const estadoInicial = {
  nome: '',
  cpf: '',
  celular: '',
  endereco: '',
  aluguel: '',
  iptu: '',
  independente: '',
  dormitorios: '',
  banheiros: '',
  garagem: '',
  quintal: '',
  caracteristicas: '',
};

const FormLocCasa = () => {
  const [campos, setCampos] = useState(estadoInicial);
  const [arquivos, setArquivos] = useState([]);
  const [status, setStatus] = useState({ tipo: '', mensagem: '' });
  const [enviando, setEnviando] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCampos((prev) => ({ ...prev, [name]: value }));
  };

  const handleArquivos = (e) => {
    setArquivos(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setStatus({ tipo: '', mensagem: '' });

    const tags = [];
    if (campos.independente === 'sim') tags.push('independente');
    if (campos.quintal === 'sim') tags.push('quintal');
    if (campos.dormitorios) tags.push(`${campos.dormitorios}-dormitorios`);
    if (campos.garagem && campos.garagem !== '0') tags.push(`${campos.garagem}-vaga-garagem`);

    const descricao = [
      campos.caracteristicas,
      campos.iptu ? `IPTU: R$ ${campos.iptu}` : '',
      campos.banheiros ? `Banheiros: ${campos.banheiros}` : '',
    ]
      .filter(Boolean)
      .join(' | ');

    const payload = {
      doc_proprietario: campos.cpf,
      nome: campos.nome,
      telefone: campos.celular,
      endereco: campos.endereco,
      valor: parseFloat(campos.aluguel) || null,
      tipo_imovel: 'casa',
      tipo_operacao: 'locacao',
      descricao: descricao || null,
      tags,
    };

    try {
      await criarImovelComImagens(payload, arquivos);
      setStatus({ tipo: 'sucesso', mensagem: 'Imóvel cadastrado com sucesso! Entraremos em contato.' });
      setCampos(estadoInicial);
      setArquivos([]);
    } catch (err) {
      setStatus({ tipo: 'erro', mensagem: err.message || 'Erro ao enviar. Tente novamente.' });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className={`${styles.container} ui-surface`}>
      <h1>Cadastro de Imóvel</h1>

      <form className={styles.form} onSubmit={handleSubmit}>

        <label>Seu Nome *</label>
        <input className="ui-input" type="text" name="nome" value={campos.nome} onChange={handleChange} required />

        <label>CPF *</label>
        <input className="ui-input" type="text" name="cpf" value={campos.cpf} onChange={handleChange} required />

        <label>Celular *</label>
        <input className="ui-input" type="tel" name="celular" value={campos.celular} onChange={handleChange} required />

        <label>Endereço do imóvel *</label>
        <input className="ui-input" type="text" name="endereco" value={campos.endereco} onChange={handleChange} required />

        <label>Valor do aluguel *</label>
        <input className="ui-input" type="number" name="aluguel" value={campos.aluguel} onChange={handleChange} required />

        <label>IPTU</label>
        <input className="ui-input" type="number" name="iptu" value={campos.iptu} onChange={handleChange} />

        <label>O imóvel é independente? *</label>
        <div className={styles.radioGroup}>
          <label><input type="radio" name="independente" value="sim" checked={campos.independente === 'sim'} onChange={handleChange} required /> Sim</label>
          <label><input type="radio" name="independente" value="nao" checked={campos.independente === 'nao'} onChange={handleChange} /> Não</label>
          <label><input type="radio" name="independente" value="entrada_independente" checked={campos.independente === 'entrada_independente'} onChange={handleChange} /> Não, porém possui entrada independente</label>
        </div>

        <label>Dormitórios *</label>
        <select className="ui-input" name="dormitorios" value={campos.dormitorios} onChange={handleChange} required>
          <option value="">Selecione</option>
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4+</option>
        </select>

        <label>Banheiros *</label>
        <select className="ui-input" name="banheiros" value={campos.banheiros} onChange={handleChange} required>
          <option value="">Selecione</option>
          <option>1</option>
          <option>2</option>
          <option>3+</option>
        </select>

        <label>Vaga de Garagem *</label>
        <select className="ui-input" name="garagem" value={campos.garagem} onChange={handleChange} required>
          <option value="">Selecione</option>
          <option>0</option>
          <option>1</option>
          <option>2</option>
          <option>3+</option>
        </select>

        <label>Possui quintal? *</label>
        <div className={styles.radioGroup}>
          <label><input type="radio" name="quintal" value="sim" checked={campos.quintal === 'sim'} onChange={handleChange} required /> Sim</label>
          <label><input type="radio" name="quintal" value="nao" checked={campos.quintal === 'nao'} onChange={handleChange} /> Não</label>
        </div>

        <label>Outras características do imóvel</label>
        <textarea className="ui-input" name="caracteristicas" rows="4" value={campos.caracteristicas} onChange={handleChange}></textarea>

        <label>Fotos do imóvel</label>
        <input className="ui-input" type="file" accept="image/*" multiple onChange={handleArquivos} />

        {status.mensagem && (
          <p className={status.tipo === 'sucesso' ? styles.sucesso : styles.erro}>
            {status.mensagem}
          </p>
        )}

        <button className="ui-button-primary" type="submit" disabled={enviando}>
          {enviando ? 'Enviando...' : 'Enviar'}
        </button>

      </form>
    </div>
  );
};

export default FormLocCasa;